export const CafeData = {
  cafeName: "کافه دلنشین",
  address: "خیابان مثال، شهر مثال، کشور مثال",
  phone: "۰۲۱-۲۲۲۲۲۲۲",
  categories: [
    "همه",
    "قهوه",
    "نوشیدنی های گرم",
    "چای و دم نوش",
    "گلاسه",
    "شیک",
    "کیک و بستنی",
  ],
  menu: [
    {
      id: "72bc5",
      name: "اسپرسو",
      price: 6000,
      category: "قهوه",
      description: "قهوه‌ای با طعم تلخ و غلظت بالا",
      fileUrl: "/jeff-siepman-ejH0zsW1ro8-unsplash.jpg",
    },
    {
      id: "93ef2",
      name: "چای سیاه",
      price: 4000,
      category: "چای و دم نوش",
      description: "چای سنتی با طعم تلخ و ملایم",
      fileUrl: "/premium_photo-1695750679584-b8e21965ef0f.avif",
    },
    {
      id: "25gh9",
      name: "آیس لاته",
      price: 8000,
      category: "نوشیدنی های گرم",
      description: "ترکیبی از اسپرسو، شیر سرد و یخ با طعم خامه",
      fileUrl: "/deepthi-clicks-nVWq-UsujW4-unsplash%20(1).jpg",
    },
    {
      id: "38jk7",
      name: "شیک",
      price: 10000,
      category: "شیک",
      description: "نوشیدنی شیری مخلوط با مواد خاص و طعم دلچسب",
      fileUrl: "/premium_photo-1673459684222-f41f2fa814df.avif",
    },
    {
      id: "83mn4",
      name: "امریکانو",
      price: 7000,
      category: "قهوه",
      description: "قهوه‌ای رقیق‌تر با طعم ملایم و کمتر اسیدی",
      fileUrl: "/jonas-jacobsson-RFHFV7lVQBY-unsplash.jpg",
    },
    {
      id: "46jk9",
      name: "ماکیاتو",
      price: 8000,
      category: "قهوه",
      description: "ترکیبی از شیر جوشیده و قهوه که طعم خامه‌ای دارد",
      fileUrl: "/premium_photo-1774416430668-382c4224e492.avif",
    },
    {
      id: "39pl2",
      name: "کاپوچینو",
      price: 9000,
      category: "قهوه",
      description: "قهوه‌ای با لایه کف و شیر خامه",
      fileUrl: "/jeff-siepman-ejH0zsW1ro8-unsplash.jpg",
    },
    {
      id: "57gh3",
      name: "کورتادو",
      price: 8500,
      category: "قهوه",
      description: "مخلوطی از قهوه و شیر با طعم ملایم و کمتر اسیدی",
      fileUrl: "/jonas-jacobsson-RFHFV7lVQBY-unsplash.jpg",
    },
    {
      id: "16mk8",
      name: "چای ماسالا",
      price: 5500,
      category: "چای و دم نوش",
      description: "ترکیبی از چای سیاه با ادویه‌های گرم و طعم متفاوت",
      fileUrl: "/premium_photo-1695750679584-b8e21965ef0f.avif",
    },
    {
      id: "72ui5",
      name: "به لیمو",
      price: 5500,
      category: "چای و دم نوش",
      description: "دمنوشی خنک با طعم تازه لیمو برای روزهای گرم",
      fileUrl: "/premium_photo-1695750679584-b8e21965ef0f.avif",
    },
    {
      id: "42nm8",
      name: "فلت لایت",
      price: 7500,
      category: "نوشیدنی های گرم",
      description: "قهوه با شیر برای دوستداران طعم‌های کرمی",
      fileUrl: "/deepthi-clicks-nVWq-UsujW4-unsplash%20(1).jpg",
    },
    {
      id: "94pg2",
      name: "لاته",
      price: 8500,
      category: "نوشیدنی های گرم",
      description: "مخلوطی از اسپرسو با شیر گرم که طعم تلخی کمتری دارد",
      fileUrl: "/deepthi-clicks-nVWq-UsujW4-unsplash%20(1).jpg",
    },
    {
      id: "27fd6",
      name: "موکا",
      price: 9500,
      category: "نوشیدنی های گرم",
      description: "ترکیبی از شکلات و شیر داغ با طعم کلاسیک",
      fileUrl: "/premium_photo-1673459684222-f41f2fa814df.avif",
    },
    {
      id: "49lp2",
      name: "موهیتو",
      price: 7000,
      category: "گلاسه",
      description: "آب گازدار با طعم نعنا، لیمو و شکر برای روزهای گرم",
      fileUrl: "/premium_photo-1774416430668-382c4224e492.avif",
    },
    {
      id: "75gt3",
      name: "اسموتی",
      price: 8500,
      category: "گلاسه",
      description:
        "مخلوطی از میوه‌ها، سبزیجات، شیر و بستنی با طعم خنک و خوشمزه",
      fileUrl: "/premium_photo-1774416430668-382c4224e492.avif",
    },
    {
      id: "75gt3",
      name: "کیک شکلاتی",
      price: 8500,
      category: "کیک و بستنی",
      description: "مخلوطی از میوه‌ها،  شیر و  خوشمزه",
      fileUrl: "/premium_photo-1673459684222-f41f2fa814df.avif",
    },
    {
      id: "75gt3",
      name: "کیک هویچ",
      price: 8500,
      category: "کیک و بستنی",
      description: "مخلوطی از میوه‌ها،  شیر و  خوشمزه",
      fileUrl: "/premium_photo-1673459684222-f41f2fa814df.avif",
    },
  ],
};
